import _ from 'lodash';
import { flattenServiceTypes } from 'common/utils/ServiceTypes';

const includesServiceType = (serviceType = {}, serviceTypes = []) => (
  serviceType.id &&
  _.some(flattenServiceTypes(serviceTypes), { id: serviceType.id })
);

export default includesServiceType;
